import { Treatment, TreatmentQuery } from '../models/Treatment'
import { Observable } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { Query } from '../../../common/api/Query'
import { IStatusService } from '../../../common/status/StatusService'
import { TreatmentDTO } from '../models/TreatmentDTO'
import { ItemList } from '../../../common/models/ItemList'
import { TreatmentApi } from '../api/TreatmentApi'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface ITreatmentService extends IInit {
  getByID(id: string): Observable<Treatment | undefined>

  getFilteredList(q: Query<TreatmentQuery>): Observable<ItemList<Treatment>>

  getFilteredItems(q: Query<TreatmentQuery>): Observable<Treatment[]>

  add(e: TreatmentDTO): Observable<Treatment | undefined>

  update(e: TreatmentDTO): Observable<Treatment | undefined>

  delete(id: string): Observable<boolean>
}

export class TreatmentService implements ITreatmentService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: TreatmentApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<TreatmentApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: TreatmentDTO): Observable<Treatment | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Treatment | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<TreatmentQuery>): Observable<ItemList<Treatment>> {
    return this._api.getFilteredList(q).pipe()
  }

  getFilteredItems(q: Query<TreatmentQuery>): Observable<Treatment[]> {
    return this._api.getFilteredItems(q).pipe()
  }

  update(e: TreatmentDTO): Observable<Treatment | undefined> {
    return this._api.update(e)
  }
}
